import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ToolsType } from '../../models/layoutClass';
import './SideNav.scss';
import { selectToolAction } from '../../redux/layout/layoutActions';
import { debounce } from '@mui/material';
import { useSharedState } from '../../utils/helpers';
import { useHistory } from 'react-router-dom';

import { container } from 'tsyringe';
import { ApiService } from '../../services/api-service';
import { ChatService } from '../../services/chat-service';
import { OrchestratorService } from '../../services/orchestrator-service';

import ExitDialog from './ExitDialog';
import Badge from '../badge/Badge';
import { PTApiService } from '../../services/ptapi-service';
import { ptPublicEvent, ptEventDetails, ptEvent } from '../../models/ptEvent';
import { PollService } from '../../services/poll-service';
import { QnaService } from '../../services/qna-service';
import { SoundService, SoundKey } from '../../services/sound-service';
// import { webRTCsdkService } from '../../services/websdk-service';
// import { MeetingConnectionState } from '../../models/meetingClass';



const SideNav = () => {
  const exitAudio = new Audio(process.env.PUBLIC_URL + '/sound/Studio_Exit.wav');

  const [apiService] = useState(container.resolve(ApiService));
  const [chatService] = useState(container.resolve(ChatService));
  const [ptApiService] = useState(container.resolve(PTApiService));
  const [pollService] = useState(container.resolve(PollService));
  const [qnaService] = useState(container.resolve(QnaService));
  const [soundService] = useState(container.resolve(SoundService));
  const [orchestratorService] = useState(container.resolve(OrchestratorService));
  // const [webRTCsdkService] = useState(container.resolve(webRTCsdkService));

  const layout: any = useSelector((state: any) => state.layout);
  const dispatch = useDispatch();

  const [showExitDialog, setShowExitDialog] = useState(false);
  const [event, setEvent] = useState<[ptPublicEvent, ptEventDetails]>(null);

  const [unreadCounterBackstage] = useSharedState(chatService.unreadBackstageCounter$);
  const [unreadCounterModerator] = useSharedState(chatService.unreadModeratorCounter$);
  const [unreadCounterPublicChat] = useSharedState(chatService.unreadPublicCounter$);
  const [unreadCounterPolls, setUnreadCounterPolls] = useState(0);
  const [unreadCounterQuestions, setUnreadCounterQuestions] = useState(0);


  // const [meetingState] = useSharedState(webRTCsdkService.meetingState$);

  const history = useHistory();

  useEffect(() => {
    // console.log('selected tool', layout.selectedTool);
    // find left-area by ID
    const letfArea = document.getElementById('left-area');
    if (letfArea) {

      if (layout.selectedTool === ToolsType.NONE) {
        letfArea.style.setProperty('width', 'calc(100% - 70px)');
      } else {
        letfArea.style.setProperty('width', 'calc(100% - 530px)');
      }
      debounce(() => {
        window.dispatchEvent(new Event('resize'));
      }, 200)();
    }
  }, [layout.selectedTool]);

  useEffect(() => {
    const subs = [
      ptApiService.ptCurrentEventInformation$.subscribe(e => {
        setEvent(e)
        console.log('EVENT ', e);
      }),
      pollService.unseenPollsCountObservable.subscribe(c => setUnreadCounterPolls(c)),
      qnaService.unseenPollsCountObservable.subscribe(c => setUnreadCounterQuestions(c)),
      orchestratorService.meetingInitializedObservable.subscribe(() => {
        pollService.fetchPolls();
        qnaService.fetchQuestions();
      })
    ];

    return () => subs.forEach(s => s.unsubscribe());
  }, []);

  const IsSelected = (tool) => {
    if (tool === layout.selectedTool) {
      return 'selected';
    }
    return '';
  }

  const selectTool = (tool) => {
    // console.log(tool);
    if (IsSelected(tool) === '') {
      dispatch(selectToolAction(tool));
    } else {
      dispatch(selectToolAction(ToolsType.NONE));
    }
  }

  const handleExit = () => {
    soundService.playSoundStart(SoundKey.Popup);
    setShowExitDialog(true);

    // route to select meeting page
    history.push('/');
  }

  const executeExit = () => {
    soundService.playSoundStart(SoundKey.Exit);

    // call leave meeting
    orchestratorService.leaveMeeting();

    // route to select meeting page
    history.push('/select-channel');
  }

  const closeExit = (value) => {
    if (value === 'cancel') {
      console.log('EXIT canceled');
    } else {
      console.log('EXIT confirmed');
      executeExit();
    }
    setShowExitDialog(false);
  }

  useEffect(() => {
    const tutoCompleted = localStorage.getItem('tutorialCompleted');
    if (!tutoCompleted || tutoCompleted !== 'true') {
      // for correct CoachMark display => reselect graphics panels by default at startup
      if (!IsSelected(ToolsType.GRAPHICS)) {
        selectTool(ToolsType.GRAPHICS);
      }
    }
  }, [])

  return (
    <section className="sidenav">
      <ul className='sidenav-top'>

        <li className='sidenav-tool' key="graphics" onClick={() => selectTool(ToolsType.GRAPHICS)}>
          <div className={'graphics ' + IsSelected(ToolsType.GRAPHICS)}></div>
          Graphics
        </li>

        {event && event.length > 0 && event[1].chatEnabled && <li className='sidenav-tool' key="chat" onClick={() => selectTool(ToolsType.CHAT)}>
          <Badge counter={unreadCounterPublicChat}></Badge>
          <div className={'chat ' + IsSelected(ToolsType.CHAT)}></div>
          Chat
        </li>}

        <li className='sidenav-tool' key="poll" onClick={() => selectTool(ToolsType.POLL)}>
          <Badge counter={unreadCounterPolls}></Badge>
          <div className={'poll ' + IsSelected(ToolsType.POLL)}></div>
          Poll
        </li>

        {event && event[1]?.qnaEnabled && <li className='sidenav-tool' key="qa" onClick={() => selectTool(ToolsType.QA)}>
          <Badge counter={unreadCounterQuestions}></Badge>
          <div className={'qa ' + IsSelected(ToolsType.QA)}></div>
          Q&amp;A
        </li>}

        <li className='sidenav-tool' key="hostchat" onClick={() => selectTool(ToolsType.HOSTCHAT)}>
          <Badge counter={unreadCounterBackstage + unreadCounterModerator}></Badge>
          <div className={'hostchat ' + IsSelected(ToolsType.HOSTCHAT)}></div>
          Host Chat
        </li>

        <li className='sidenav-tool' key="people" onClick={() => selectTool(ToolsType.PEOPLE)}>
          <div className={'people ' + IsSelected(ToolsType.PEOPLE)}></div>
          People
        </li>

        <li className='sidenav-tool' key="settings" onClick={() => selectTool(ToolsType.SETTINGS)}>
          <div className={'settings ' + IsSelected(ToolsType.SETTINGS)}></div>
          Settings
        </li>

        {/* <li key="resync" className="sidenav-tool" onClick={onResyncCaspar}>
            <div className="resync-caspar"></div>
            Resync
        </li> */}
      </ul>
      {/* <ul className='sidenav-bottom'>
        <li className='sidenav-tool' key="exit" onClick={() => handleExit()}>
          <div className={'exit '}></div>
          Exit
        </li>
      </ul> */}
      <ExitDialog open={showExitDialog} onClose={(e) => closeExit(e)}></ExitDialog>
    </section>
  );
}

export default SideNav;